import React from 'react';

import ActionItemWidget from '../actionItem/actionItemWidget';
import WorkStreamRow from '../workStream/workStreamRow';
import GoalRow from '../goal/goalRow';
import KeyResultsRow from '../keyResults/keyResultRows';
import OneNoteRow from '../oneNote/oneNoteRow';
import KpiRow from '../kpi/kpiRow';
import SearchNotFound from './searchNotFound';
import NoItemsFound from './noItemsFound';

const RowItems = ({ id, items, toggleChkBox, selectedItems, searchVal }) => {
  const type = id;
  if (items && items.length) {
    if (type == 'workstream') {
      return items.map((item) => (
        <WorkStreamRow
          key={`WS-${item.id}`}
          id={type}
          item={item}
          selectedItems={selectedItems}
          toggleChkBox={toggleChkBox}
        />
      ));
    }
    if (type == 'objective') {
      return items.map((item) => (
        <GoalRow
          key={`Goal-${item.id}`}
          id={type}
          item={item}
          selectedItems={selectedItems}
          toggleChkBox={toggleChkBox}
        />
      ));
    }
    if (type == 'key_result') {
      return items.map((item) => (
        <KeyResultsRow
          key={`${type}_${item.goal_id}`}
          source="meeting"
          item={item}
          toggleChkBox={toggleChkBox}
          selectedItems={selectedItems}
        />
      ));
    }
    if (type == 'ai') {
      const events = { toggleChkBox: toggleChkBox };
      const header = [
        { id: 'checkbox', name: '', style: { width: '5%' } },
        {
          id: 'description',
          name: 'Issue',
          style: {
            width: '41.5%',
            textAlign: 'left',
            fontWeight: 'bold',
            paddingLeft: '10px',
          },
        },
        { id: 'owner', name: 'Owner', style: { width: '15%', textAlign: 'left' } },
        { id: 'owner', name: 'Workstream', style: { width: '18%', textAlign: 'left', paddingLeft: '4px' } },
        { id: 'due_date', name: 'Due', style: { width: '14%' } },
        { id: 'state', name: 'Status' },
      ];
      return (
        <div>
          <ActionItemWidget
            key={'ai_widget_table_ai'}
            header={header}
            rows={items}
            readItemsFromProps="1"
            checkbox="1"
            events={events}
            selectedItems={selectedItems}
          />
        </div>
      );
    }
    if (type == 'kpi') {
      return items.map((item) => (
        <KpiRow
          key={`KPI-${item.id}`}
          id={type}
          item={item}
          selectedItems={selectedItems}
          toggleChkBox={toggleChkBox}
        />
      ));
    }
    if (type == 'onenote') {
      return (
        <ul className="onenote-ul-wrapper" id="example_tree">
          {items.map((item) => (
            <OneNoteRow item={item} toggleChkBox={toggleChkBox} />
          ))}
        </ul>
      );
    }
    if (type == 'last_meeting_actions') {
      const events = { toggleChkBox: toggleChkBox };
      const header = [
        { id: 'checkbox', name: '', style: { width: '3.5%' } },
        { id: 'description', name: 'Issue', style: { width: '41%', textAlign: 'left', paddingLeft: '10px' } },
        { id: 'owner', name: 'Owner', style: { width: '14%', textAlign: 'left' } },
        { id: 'owner', name: 'Workstream', style: { width: '15%', textAlign: 'left', paddingLeft: '4px' } },
        { id: 'due_date', name: 'Due', style: { width: '12%', textAlign: 'left' } },
        { id: 'rag', name: 'Rating', style: { width: '6%' } },
        { id: 'state', name: 'Status' },
      ];
      return (
        <div>
          <ActionItemWidget
            key={'ai_widget_table_last_action_items'}
            header={header}
            rows={items}
            readItemsFromProps="1"
            checkbox="1"
            events={events}
            selectedItems={selectedItems}
          />
        </div>
      );
    }
  } else {
    return type !== 'last_meeting_actions' ? <SearchNotFound type={type} searchVal={searchVal} /> : <NoItemsFound />;
  }
};

export default RowItems;
